import { CommonAPIService } from '/src/servicehandlers/CommonHandler';

export class APIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  ping(router, store){
    const url = '/api/ping'
    return this.CommonAPIService.getCall(url, '', router, store)
  }

  getReasonCodes(router, store){
    const url = `/api/aireporting/reason_codes`
    return this.CommonAPIService.getCall(url, '', router, store)
  }

  submitAIReport(payload, router, store){
    const url = `/api/aireporting`
    return this.CommonAPIService.postCall(url, payload, router, store)
  }

  // Password reset methods - no auth required
  post(url, payload) {
    const fullUrl = this.CommonAPIService.apiUrl + '/api' + url;
    const axios = require('axios');
    return axios.post(fullUrl, payload)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }

  get(url) {
    const fullUrl = this.CommonAPIService.apiUrl + '/api' + url;
    const axios = require('axios');
    return axios.get(fullUrl)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }
}
export default APIService;
